import { ExchangeId, OhlcInterval, SecurityType } from './providers/utProto/enums_pb';

export enum QUOTE_UPDATE_TYPE {
  DPR = 'dpr',
  QUOTE = 'quote',
  DEPTH = 'depth',
  INDEX = 'index',
  LTP_CLOSE = 'LtpAndClosePrice',
  GAINER_LOSER = 'GainerLoser',
  OPEN_INTEREST = 'OpenInterest',
  MOST_ACTIVE = 'MostActive',
  NOTICE = 'Notice',
  SESSION_CHANGE = 'SessionChange',
  TOP_DEPTH = 'TopDepth',
  OHLC = 'OHLC',
  THROTTLER_HANDLER = 'THROTTLER_HANDLER',
  THROTTLER_INDEX_HANDLER = 'THROTTLER_INDEX_HANDLER',
  THROTTLER_DEPTH_HANDLER = 'THROTTLER_DEPTH_HANDLER',
  THROTTLER_DPR_HANDLER = 'THROTTLER_DPR_HANDLER',
  THROTTLER_LTP = 'THROTTLER_LTP',
  UPDATED_THROTTLER_LTP = 'UPDATED_THROTTLER_LTP', // This is for marketId and securityId
  FIFTY_DEPTH = 'FIFTY_DEPTH',
  INDICATIVE_CLOSE_PRICE = 'INDICATIVE_CLOSE_PRICE',
  LIFETIME_HIGH_LOW = 'LIFETIME_HIGH_LOW',
  THROTTLER_LIFETIME_HIGH_LOW_HANDLER = 'THROTTLER_LIFETIME_HIGH_LOW_HANDLER',
}

export enum SYMBOL_SUBSCRIPTION_TYPE {
  SUBSCRIBED,
  UNSUBSCRIBED,
  FIRST_FETCH_SUBSCRIPTION,
  FIRST_FETCH_SUBSCRIPTION_NEW,
  MAX,
}

export enum SOCKET_MSG_TYPES {
  FIRST_FETCH = 0,
  SECURITY_ID_MAPPING = 1,
  SECURITY_ID_MAPPING_COMPLETED = 2,
  SESSION_MESSAGES = 3,
  SYMBOL_SESSION_INFO = 4,
  OHLC_DATA = 5,
  OHLC_DATA_COMPLETED = 6,
  SNAPSHOT_DATA = 7,
  SNAPSHOT_DATA_COMPLETED = 8,
  QUOTE = 9,
  SESSION_CHANGE = 10,
  NOTICE = 11,
  INDEX_VALUE = 12,
  OPEN_INTEREST = 13,
  AUCTION_UPDATE = 14,
  AGGREGATE_QUOTE = 15,
  MARKET_STATUS = 16,
  DAILY_PRICE_RANGE = 17,
  TRADE_EXECUTION_RANGE = 18,
  SYMBOL_MARKET_INFO = 19,
  TOP_DEPTH_QUOTE = 20,
  TBT_DATA = 21,
  TRIMMED_QUOTE = 22,
  INDEX_UNDERLYINGS = 23,
  MOST_ACTIVE = 24,
  TOP_GAINERS_LOSERS = 25,
  GROUP_QUOTE = 26,
  SYMBOL_SESSION_CHANGE = 27,
  IV_GREEK = 28,
  PRICE_RANGE = 29,
  Login_Response = 30,
  LTP_Close_PRICE = 31,
  FIFTY_DEPTH = 37,
  FIRST_FETCH_NEW = 38,
  FIFTY_WEEK_HIGH_LOW = 39,
  CLOSE_PRICE = 40,
  INDICATIVE_CLOSE_PRICE = 41,
}

export enum MarketIDMap {
  BSECM = ExchangeId.EXCHANGEID_BSECM,
  BSEFO = ExchangeId.EXCHANGEID_BSEFO,
  NSECM = ExchangeId.EXCHANGEID_NSECM,
  NSEFO = ExchangeId.EXCHANGEID_NSEFO,
  ESMNSE = ExchangeId.EXCHANGEID_ESMNSE,
  ESM = ExchangeId.EXCHANGEID_ESMNSE,
  NSECDS = ExchangeId.EXCHANGEID_NSECDS,
  BSECDS = ExchangeId.EXCHANGEID_BSECDS,
  MSECD = ExchangeId.EXCHANGEID_MSECD,
  MSEFO = ExchangeId.EXCHANGEID_MSEFO,
  PLUS = ExchangeId.EXCHANGEID_PLUS,
  MCX = ExchangeId.EXCHANGEID_MCX,
}

export enum SECURITYTYPE {
  COMMON_STOCK = SecurityType.SECURITYTYPE_COMMON_STOCK,
  FUTURE = SecurityType.SECURITYTYPE_FUTURE,
  OPTION = SecurityType.SECURITYTYPE_OPTION,
  SPREAD = SecurityType.SECURITYTYPE_SPREAD,
  AUCTION = SecurityType.SECURITYTYPE_AUCTION,
  MAX = SecurityType.SECTYPE_MAX,

}

export enum CandleIntervals {
  '1m' = OhlcInterval.OHLCINTERVAL_1_MIN,
  '3m' = OhlcInterval.OHLCINTERVAL_3_MIN,
  '5m' = OhlcInterval.OHLCINTERVAL_5_MIN,
  '10m' = OhlcInterval.OHLCINTERVAL_10_MIN,
  '15m' = OhlcInterval.OHLCINTERVAL_15_MIN,
  '30m' = OhlcInterval.OHLCINTERVAL_30_MIN,
  '1h' = OhlcInterval.OHLCINTERVAL_1_HOUR,
  '4h' = OhlcInterval.OHLCINTERVAL_4_HOUR,
  '1d' = OhlcInterval.OHLCINTERVAL_1_DAY,
  '5d' = OhlcInterval.OHLCINTERVAL_5_DAYS,
  '1M' = OhlcInterval.OHLCINTERVAL_1_MONTH
}

export enum WebsocketMessages {
  AuthenticationSuccess = 'Authentication Successful'
}

export enum HeartBeat {
  Heart_Beat = 1
}